import * as mojs from "mo-js";

export function getFavoriteProducts(): string[] {
	let productIds: string[] = [];
	if (localStorage.getItem('favorite-products')) {
		productIds = JSON.parse(localStorage.getItem('favorite-products'));
	}

	return productIds;
}

export function getFavoriteProjects(): string[] {
	let projectIds: string[] = [];
	if (localStorage.getItem('favorite-projects')) {
		projectIds = JSON.parse(localStorage.getItem('favorite-projects'));
	}

	return projectIds;
}

export function checkOnPageFavorites(): void {
	$('.js-save-for-later').each(function() {
		if ($(this).data('modelnumber')) {
			let favoriteProducts = getFavoriteProducts();
			updateSavedStateProducts(this, favoriteProducts);
		}
		if ($(this).data('project')) {
			let favoriteProjects = getFavoriteProjects();
			updateSavedStateProjects(this, favoriteProjects);
		}
	});
}

export function updateSavedStateProjects(el, favoriteProjects) {
	let project = $(el).data('project');

	if (favoriteProjects.indexOf(project) > -1) {
		let $favoriteIcon = $(el).find('.icon-favorite-outline');
		if(!($favoriteIcon.length > 0 ))
		{
			$favoriteIcon = $(el).find('.icon-star-outline');
		}
		$favoriteIcon.addClass('state-checked');
		let $label = $(el).find('.js-save-for-later-label');

		if ($label.length && $label.data('checked')) {
			$label.text($label.data('checked'));
		}
	}
}

export function updateSavedStateProducts(el, favoriteProducts) {
	let modelNumber = $(el).data('modelnumber');

	if (favoriteProducts.indexOf(modelNumber) > -1) {
		let $favoriteIcon = $(el).find('.icon-favorite-outline');
		if(!($favoriteIcon.length > 0 ))
		{
			$favoriteIcon = $(el).find('.icon-star-outline');
		}
		$favoriteIcon.addClass('state-checked');
		let $label = $(el).find('.js-save-for-later-label');

		if ($label.length && $label.data('checked')) {
			$label.text($label.data('checked'));
		}
	}
}

export function addFavorite(modelNumber, projectId) {
	let productIds = getFavoriteProducts();
	let projectIds = getFavoriteProjects();
    if(modelNumber != null)
	{
		if (productIds.indexOf(modelNumber) < 0) {
			productIds.push(modelNumber);
		}
		localStorage.setItem('favorite-products', JSON.stringify(productIds));
    }
	if(projectId != null)
	{
		if (projectIds.indexOf(projectId) < 0) {
			projectIds.push(projectId);
		}
		localStorage.setItem('favorite-projects', JSON.stringify(projectIds));
	}

	
}

export function removeFavorite(modelNumber, projectId) {
	let productIds = getFavoriteProducts();
    let projectIds = getFavoriteProjects();
	if(modelNumber != null)
	{
		if (productIds.indexOf(modelNumber) > -1) {
			productIds.splice(productIds.indexOf(modelNumber), 1);
		}
		localStorage.setItem('favorite-products', JSON.stringify(productIds));
    }
	if(projectId != null)
    { 
	  if (projectIds.indexOf(projectId) > -1){
		projectIds.splice(projectIds.indexOf(projectId), 1);
	  }
	  localStorage.setItem('favorite-projects', JSON.stringify(projectIds));
	}
}

export function init() {
	if (window['favoriteToggleInitialized']) { return; }

	checkOnPageFavorites();

	$(document).on('click', '.js-save-for-later', function(e) {
		e.preventDefault();
		e.stopPropagation();        
		let $this = $(this);		
		console.log(e.target.dataset);
		console.log($this.data('modelnumber'));
		let $favoriteIcon = $this.find('.icon-favorite-outline');
		if(!($favoriteIcon.length > 0))
		{
			$favoriteIcon = $this.find('.icon-star-outline');
		}		
		let $label = $this.find('.js-save-for-later-label');
		let isChecked = $favoriteIcon.hasClass('state-checked');
		let modelNumber = $this.data('modelnumber');
		let projectId = $this.data('project');		
		$favoriteIcon.toggleClass('state-checked');
		$this.toggleClass('state-favorited');

		if (!isChecked) {
			addFavorite(modelNumber, projectId);
		} else {
			removeFavorite(modelNumber, projectId);
		}

		let favoriteProducts = getFavoriteProducts();
		updateSavedStateProducts(this, favoriteProducts);

		let favoriteProjects = getFavoriteProjects();
		updateSavedStateProjects(this, favoriteProjects);

		if (!isChecked && $label.length && $label.data('checked')) {
			$label.text($label.data('checked'));
		} else if ($label.length && $label.data('unchecked')) {
			$label.text($label.data('unchecked'));
		}

		// This event triggers the Favorites counter in the nav to update
		window.dispatchEvent(new Event('favorites'));
	    
	});

	window['favoriteToggleInitialized'] = true;
}
